import { type IntegrationSettingKey } from '@webapp/core/services/IntegrationsAPIClient/IntegrationsAPIClient.service'

export type IntegrationSettingValueByKey = {
  use_bill_tax: boolean
  auto_bill_sync: boolean
  post_bills_at_top_level: boolean
  account_id: string
  push_bill_attachments: boolean
  netsuite_upload_folder: string
  override_netsuite_tax_amount: boolean
  merge_account_currency: string
  merge_account_country: string
  push_posted_bills: boolean
  business_central_company_id: string
  business_central_company_remote_id: string
}

export const INTEGRATION_SETTING_TYPE_MAP = {
  use_bill_tax: 'boolean',
  auto_bill_sync: 'boolean',
  post_bills_at_top_level: 'boolean',
  account_id: 'string',
  push_bill_attachments: 'boolean',
  netsuite_upload_folder: 'string',
  override_netsuite_tax_amount: 'boolean',
  merge_account_currency: 'string',
  merge_account_country: 'string',
  push_posted_bills: 'boolean',
  business_central_company_id: 'string',
  business_central_company_remote_id: 'string',
}

export interface IntegrationSettingConstructor<
  T extends IntegrationSettingKey = IntegrationSettingKey,
> {
  id: string
  settingKey: T
  settingValue: IntegrationSettingValueByKey[T]
}

export class IntegrationSetting<
  T extends IntegrationSettingKey = IntegrationSettingKey,
> {
  readonly id: string
  readonly settingKey: T
  readonly settingValue: IntegrationSettingValueByKey[T]

  constructor(data: IntegrationSettingConstructor<T>) {
    this.id = data.id
    this.settingKey = data.settingKey
    this.settingValue = data.settingValue
    this.validateSettingValue()
  }

  private validateSettingValue(): void {
    const expectedType = INTEGRATION_SETTING_TYPE_MAP[this.settingKey]
    const actualType = typeof this.settingValue
    if (expectedType !== actualType) {
      console.error(
        `IntegrationSetting: settingValue for key '${this.settingKey}' must be ${expectedType}, got ${actualType}`
      )
    }
  }

  get isEnabled(): boolean {
    return this.settingValue === true
  }
}
